var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Button } from '../Button';
import { AiOutlineSearch } from '../../icons';
import { TextInput } from './text-input';
export var SearchInput = React.forwardRef(function (_a, ref) {
    var defaultValue = _a.defaultValue, onSearch = _a.onSearch, _b = _a.clearable, clearable = _b === void 0 ? false : _b, loading = _a.loading, props = __rest(_a, ["defaultValue", "onSearch", "clearable", "loading"]);
    var _c = React.useState(defaultValue), searchText = _c[0], setSearchText = _c[1];
    var forwardRef = React.useRef(null);
    React.useEffect(function () { if (ref) {
        if (typeof ref === "function") {
            ref(forwardRef.current);
        }
        else {
            ref.current = forwardRef.current;
        }
    } });
    return _jsx(TextInput, __assign({ ref: forwardRef, loading: loading, clearable: clearable, noDelayed: true, clearableOnEscape: true, placeholder: 'Buscar . . .', contentRight: _jsx(Button, __assign({ hidden: loading, noneTheme: true, flat: true, noFocuseable: true, borderRadius: 5, padding: 2, minHeight: 0, disabled: !searchText, onClick: function () { return onSearch(searchText); } }, { children: _jsx(AiOutlineSearch, { fontSize: 20 }) })) }, props, { value: searchText, onChange: function (e) {
            setSearchText(e.target.value);
            props.onChange && props.onChange(e);
        }, onEnterUp: function () { return onSearch(searchText); }, onClear: function () {
            setSearchText('');
            onSearch('');
        } }));
});
